import { MaterialModule } from './../material/material.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadComponent } from './upload/upload.component';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [UploadComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  exports: [
    UploadComponent
  ]
})
export class FileModule { }
